import { render } from "./withdraw_log.vue?vue&type=template&id=8f534d08&scoped=true"
import script from "./withdraw_log.vue?vue&type=script&lang=js"
export * from "./withdraw_log.vue?vue&type=script&lang=js"

import "./withdraw_log.vue?vue&type=style&index=0&id=8f534d08&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f534d08"]])

export default __exports__